import {Heartbeat} from "@/utils/stateApiType";

export function hasConsecutiveZeros(data: Heartbeat[], count: number) {
    const HeartbeatDetail = data.slice(data.length-count,data.length);
    let consecutiveCount = 0;
    let paddingNum = 0
    for (const item of HeartbeatDetail) {
        if (item.status === 0) {
            consecutiveCount++;
            if (consecutiveCount === count) {
                return 0;
            }
        } else {
            consecutiveCount = 0;
        }
    }

    for (const item of HeartbeatDetail) {
        if (item.status === 2 || item.status === 3) {
            paddingNum++;
            if (paddingNum === count) {
                return 2;
            }
        } else {
            paddingNum = 0;
        }
    }

    return 1;
}

export function UtxTime(time: string) {

    const formattedUtcDateStr = time.replace(' ', 'T') + 'Z';

    const utcDate = new Date(formattedUtcDateStr);

    const timestamp = utcDate.getTime();

    return new Date(timestamp).toLocaleString()
}

export const StateItemText = (val: number) => {
    if (val === 1) {
        return 'System Operational'
    }
    if (val === 2 || val === 3) {
        return 'Service Maintenance in Progress'
    }
    return 'Degraded Service'

}

export const StateText = (val: number) => {
    if (val === 1) {
        return 'All Systems Operational'
    }
    if (val === 2 || val === 3) {
        return 'Partially Degraded Service'
    }
    return 'Degraded Service'

}